import React from 'react';
import { withTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import withCurrency from '../../containers/withCurrency';

const ChildItem = ({ itemDescription, quantity, value }) => (
  <>
    <span className="font-weight-bold child__description">
      {itemDescription}
    </span>
    <span className="child__quantity">x{quantity}</span>
    <span className="child__total">{value}</span>
  </>
);

ChildItem.propTypes = {
  itemDescription: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
};

const ChildItemsMinimal = ({ items, t, formatCurrencyForCalculation }) => (
  <>
    <div className="child-items__header">
      <span className="child-items__header__text">
        {t('weblink:additionalItems')}
      </span>
      <hr className="child-items__header__line" />
    </div>
    <div className="child-items__grid">
      {items.map(childItem => (
        <ChildItem
          key={childItem.id}
          itemDescription={childItem.productOption?.description || ''}
          quantity={childItem.quantity}
          value={formatCurrencyForCalculation(
            parseFloat(childItem.unitAmount) * childItem.quantity,
          )}
        />
      ))}
    </div>
  </>
);

ChildItemsMinimal.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  t: PropTypes.func.isRequired,
  formatCurrencyForCalculation: PropTypes.func.isRequired,
};

export default withTranslation()(withCurrency(observer(ChildItemsMinimal)));
